import EmailButton from './EmailButton';

export default EmailButton;
